import LegalPageLayout from "@/components/LegalPageLayout";
import SEO from "@/components/SEO";

// TODO: upload the professional headshot to your asset host (same place as
// /static/hero-abstract.jpg etc.) and point this at the real URL.
const founderPhoto = "https://images.checkoutdm.com/static/founder-prince-jindal.jpg";

export default function AboutUs() {
  return (
    <LegalPageLayout eyebrow="Company" title="About Checkout DM">
      <SEO
        title="About Us | Checkout DM"
        description="Checkout DM connects Instagram buyers and merchants directly through DMs — no website, no cart abandonment, just a secure checkout link and a confirmed sale."
        path="/about"
      />
      <p>
        Checkout DM was built on a simple observation: a huge amount of
        Instagram commerce already happens in DMs — a buyer messages "is this
        available?", a merchant sends UPI details, and everyone waits and
        hopes the payment gets confirmed manually. That back-and-forth loses
        sales.
      </p>

      <p>
        We connect buyers and merchants inside Instagram itself. No website,
        no separate app, no cart abandonment — just a DM, a secure checkout
        link, and a confirmed sale, all without the merchant leaving
        Instagram.
      </p>

      <h2>Who's behind it</h2>

      <img
        src={founderPhoto}
        alt="Prince Jindal, founder of Checkout DM"
        style={{
          width: "140px",
          height: "140px",
          borderRadius: "1rem",
          objectFit: "cover",
          float: "left",
          marginRight: "1.5rem",
          marginBottom: "0.5rem",
        }}
      />

      <p>
        I'm <strong>Prince Jindal</strong>, and I build and run Checkout DM
        myself — there's no team behind the curtain.
      </p>

      <p>
        Before this, I founded and ran{" "}
        <a href="https://healthyceleb.com" target="_blank" rel="noopener noreferrer">
          HealthyCeleb.com
        </a>
        , a celebrity health, diet, and biography site read by audiences
        worldwide. I wrote the early articles myself, then grew and led a
        team of around 20 writers and editors as it scaled — at its peak the
        site drew multi-millions visitors a month. Running that taught me how
        to build something people actually want to use, and how to run a
        real operation rather than just write code.
      </p>

      <p>
        I also run{" "}
        <a
          href="https://instagram.com/princejindalai"
          target="_blank"
          rel="noopener noreferrer"
        >
          @PrinceJindalAI
        </a>
        , where I teach Indian creators and small businesses how to use AI
        and automation, and I've spent 13+ years trading NSE/BSE — which is
        probably why I default to thinking in systems rather than manual
        processes. Checkout DM is that same instinct applied to Instagram
        selling: automate the checkout, keep the merchant in the
        conversation, and let the payment confirm itself.
      </p>

      <p style={{ clear: "both" }}>
        I design, build, and maintain Checkout DM end-to-end, so when you
        email support, you're talking to the person who actually built the
        product — not a support queue.
      </p>

      <h2>What we believe</h2>
      <ul>
        <li>Merchants shouldn't need a website to run a real business.</li>
        <li>Checkout should happen where the conversation already is.</li>
        <li>Payments should be secure by default — signed links, verified webhooks, no manual payment screenshots.</li>
      </ul>

      <h2>Built in India, growing toward every Instagram seller</h2>
      <p>
        Checkout DM is made for the creators, home businesses, and brands
        who built their audience on Instagram and sell directly through it —
        from festival-season resellers to full-time DM-based storefronts.
        Today, merchant payouts run through Razorpay, UPI, and bank
        transfer, so we're built first for merchants with an Indian bank
        account — while buyers can already pay from anywhere by card.
        International merchant payouts are on the roadmap as we grow beyond
        India.
      </p>
      <p>
        <em>Operated by M/s Healthy Celeb, Panchkula, Haryana, India.</em>
      </p>

      <h2>Get in touch</h2>
      <p>
        Questions, partnership ideas, or feedback — I personally read every
        message. Reach me at{" "}
        <a href="mailto:support@checkoutdm.com">support@checkoutdm.com</a>, on{" "}
        <a
          href="https://instagram.com/princejindalai"
          target="_blank"
          rel="noopener noreferrer"
        >
          Instagram
        </a>
        , or via our <a href="/contact">Contact page</a>.
      </p>
    </LegalPageLayout>
  );
}
